import { Checkbox } from '@eventbrite/eds-checkbox';
import { dangerousGettext, gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import PropTypes from 'prop-types';
import React from 'react';

import './TermsCheckbox.scss';

const TermsCheckbox = ({ errors, field, form, touched }: any) => {
    const shouldShowErrors =
        touched.areTermsAccepted && !!errors.areTermsAccepted;

    return (
        <>
            <Checkbox
                aria-label={gettext(
                    'I accept the Eventbrite Terms of service.',
                )}
                hasError={shouldShowErrors}
                id="termsAccepted"
                name="termsAccepted"
                onChange={(val: boolean) => form.setFieldValue(field.name, val)}
                checked={field.value}
                shouldHighlightError
            >
                {/* @ts-expect-error Typography isn't used to dangerouslySetInnerHTML. */}
                <Typography
                    as="p"
                    color="neutral-800"
                    variant="body-md"
                    className="checkbox-label-text"
                    dangerouslySetInnerHTML={{
                        __html: dangerousGettext(
                            'I accept the <a href="%(termsUrl)s" target="_blank">Eventbrite Terms of Service</a> and <a href="%(guidelinesUrl)s" target="_blank">Community Guidelines</a>, and have read the <a href="%(privacyUrl)s" target="_blank">Privacy Policy</a>.',
                            {
                                termsUrl: '/tos',
                                guidelinesUrl: '/community-guidelines',
                                privacyUrl: '/privacypolicy',
                            },
                        ).toString(),
                    }}
                />
                {shouldShowErrors && (
                    <Typography as="p" className="error" variant="body-sm">
                        {errors.areTermsAccepted}
                    </Typography>
                )}
            </Checkbox>
        </>
    );
};

TermsCheckbox.propTypes = {
    buttonClasses: PropTypes.string,
    required: PropTypes.bool,
    submitFailed: PropTypes.bool,
    isStatic: PropTypes.bool,
    autoFocus: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFormReset: PropTypes.func,
};

export default TermsCheckbox;
